module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon7.3049013c.svg";